import { useUpdateStudentDifficultyMutation } from 'util/rtk-api'

import { DifficultyDropdown } from 'components/tables/difficulty-dropdown'
import styles from 'css/components/missing-level-modal.module.css'
import { Difficulty, StudentEntry } from '@all-for-one/shared-types'

type MissingLevelModalProps = {
	classId: string
	students: StudentEntry[]
}

// Blocking gate for launching a lesson or opening a classroom with students
// that have no learning level set -- CEO was explicit (8/21) that a
// dismissible alert was a misunderstanding of the ask: the teacher must be
// able to set the level right here, and must not be able to proceed until
// every listed student has one. No dismiss control on purpose.
export const MissingLevelModal = ({ classId, students }: MissingLevelModalProps) => {
	const [updateStudentDifficulty] = useUpdateStudentDifficultyMutation()

	const handleChange = async (studentId: string, difficulty: Difficulty) => {
		try {
			await updateStudentDifficulty({ classId, studentId, difficulty }).unwrap()
		} catch (error) {
			console.error('Error setting student difficulty:', error)
		}
	}

	return (
		<div className="overlay">
			<div className="overlay-content-container">
				<div className="overlay-content-header">
					<h3>Set a learning level to continue</h3>
				</div>
				<div className="overlay-content-body">
					<p>
						{students.length} student{students.length > 1 ? 's' : ''} in this class {students.length > 1 ? "don't" : "doesn't"} have a learning level set. Set one for each student below to continue.
					</p>
					<ul className={styles.list}>
						{students.map(student => (
							<li key={student.studentId} className={styles.row}>
								<span className={styles.name}>{student.studentName?.trim() || 'Unnamed student'}</span>
								<DifficultyDropdown
									currentDifficulty={student.difficulty}
									handleDifficultyChange={(difficulty) => handleChange(student.studentId, difficulty)}
								/>
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	)
}
